import { render, staticRenderFns } from "./pengesahan.vue?vue&type=template&id=19e6115c&scoped=true"
import script from "./pengesahan.vue?vue&type=script&lang=js"
export * from "./pengesahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e6115c",
  null
  
)

export default component.exports